import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';

import { MD_MEDIA_QUERY, SM_MOBILE_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps } from './types';
import { getTemplate } from '~pricing/components/DetailsPackagesView/useStyles';

export default createMemoStyles(({ spacing, palette, elevation, pricingPalette, packageTheme }: PricingAppTheme) => ({
  AccordionControl: {
    marginBottom: spacing[4],
    '& [role=button]': {
      backgroundColor: palette.background.main,
      '& span:first-child': {
        paddingLeft: spacing[3],
        '& strong': {
          fontSize: 13,
          [MD_MEDIA_QUERY]: {
            fontSize: 16,
          },
        },
      },
    },
    '& ul li > div > div': {
      padding: 0,
    },
  },
  Cell: {
    border: `1px solid ${pricingPalette.colors.pebble}`,
    borderTop: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `0 ${spacing[1]}px`,
    textAlign: 'center',
    [MD_MEDIA_QUERY]: {
      '&:not(:last-child)': {
        borderRight: 'none',
      },
    },
  },
  Highlighted: {
    backgroundColor: ({ packageName }: StyleProps) => (packageName ? packageTheme[packageName].primary : 'transparent'),
    color: pricingPalette.colors.white,
    '& a': {
      color: pricingPalette.colors.white,
    },
  },
  DetailRow: {
    ...getTemplate(),
    fontSize: 13,
    color: pricingPalette.colors.charcoal,
  },
  HighlightFeature: {
    backgroundColor: palette.background.primary.light,
  },
  Feature: {
    padding: spacing[4],
    borderLeft: `1px solid ${pricingPalette.colors.pebble}`,
    borderBottom: `1px solid ${pricingPalette.colors.pebble}`,
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    [MD_MEDIA_QUERY]: {
      borderLeft: 'none',
    },
  },
  Bullet: {
    borderRadius: '100%',
    backgroundColor: ({ packageName }: StyleProps) => (packageName ? packageTheme[packageName].primary : 'none'),
    width: 10,
    height: 10,
    display: 'block',
  },
  BulletInverse: {
    composes: '$Bullet',
    backgroundColor: pricingPalette.colors.white,
  },
  ExpandCollapseContainer: {
    [MD_MEDIA_QUERY]: {
      left: 0,
      position: 'sticky',
      zIndex: elevation.sky - 1,
      margin: [-30, 0, 0, 10],
      width: 'fit-content',
    },
  },
  ExpandCollapse: {
    fontSize: 13,
    left: spacing[3],
    backgroundColor: 'transparent',
    color: pricingPalette.colors.link,
    border: 'none',
    borderLeft: `1px solid ${pricingPalette.colors.pebble}`,
    borderRight: `1px solid ${pricingPalette.colors.pebble}`,
    padding: spacing[4],
    width: '100%',
    '&:hover, &:focus': {
      textDecoration: 'none',
      backgroundColor: 'transparent !important',
      color: [pricingPalette.colors.link, '!important'],
      border: 'none',
    },
    '& svg': {
      marginLeft: 5,
    },
    [SM_MOBILE_MEDIA_QUERY]: {
      display: 'inline-block',
      padding: 0,
      borderRadius: 0,
      left: 0,
    },
    [MD_MEDIA_QUERY]: {
      display: 'flex',
      width: 'auto',
      padding: 0,
      border: 'none',
      borderRadius: 0,
    },
  },
  TooltipContainer: {
    '&:hover $Tooltip': {
      display: 'inline-block',
    },
    [MD_MEDIA_QUERY]: {
      position: 'relative',
    },
  },
  TooltipIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
    fontSize: 13,
    color: 'white',
    borderRadius: '100%',
    backgroundColor: pricingPalette.colors.stone,
    cursor: 'help',
    '&:hover': {
      backgroundColor: pricingPalette.colors.flint,
    },
    marginLeft: 5,
  },
  Tooltip: {
    display: 'none',
    color: pricingPalette.colors.charcoal,
    cursor: 'auto',
  },
}));
